import React, { useState } from 'react';
import classNames from 'classnames';
import DragScroll from 'react-indiana-drag-scroll';
import Modal from '../../../../components/Modal';
import { HomeTab } from '../../../../types/home/tab';
import WidgetPreviewEventWrap from '../../../widget/common/widgetPreview/widgetPreviewEvent/WidgetPreviewEventWrap';
import PageHeader from '../../../../components/preview/PageHeader';
import { TabHeaderListStyle, TabHeaderStyle, TabListPreviewStyle } from './style';

interface HomeTabListPreviewProps {
  tabList: HomeTab[];
  onClose: () => void;
}

const EVENT_MOCK_DATA = [
  {
    id: 1178,
    eventId: 2965,
    exposureStartDate: '2024-03-25T09:41:44.000Z',
    exposureEndDate: '2024-04-30T09:41:44.000Z',
    img: {
      '0': [
        {
          id: 2861,
          url: 'https://image.dev-amondz.com/rectangle-images/e5d44ec9-cf6e-449a-8e9f-d48ffd5c08e5.jpg',
          path: null,
          width: 1035,
          height: 1125,
        },
      ],
      '1': [
        {
          id: 2873,
          url: 'https://image.dev-amondz.com/rectangle-images/694d3493-e9f7-49c1-864a-3c8c34e0612e.jpg',
          path: null,
          width: 2892,
          height: 1500,
        },
      ],
    },
    no: 2,
    linkId: 2965,
    linkName: '상미 기획전 필터 테스트 미라클',
    status: 2,
    url: 'https://image.dev-amondz.com/rectangle-images/e5d44ec9-cf6e-449a-8e9f-d48ffd5c08e5.jpg',
    memo: '1111',
    eventPeriod: {
      startDate: null,
      endDate: null,
    },
    exposurePeriod: {
      startDate: '2024-03-25T09:41:44.000Z',
      endDate: '2024-04-30T09:41:44.000Z',
    },
  },
  {
    id: 1179,
    eventId: 2905,
    exposureStartDate: '2024-03-28T09:01:57.000Z',
    exposureEndDate: '2024-04-04T09:01:57.000Z',
    img: {
      '0': [
        {
          id: 2862,
          url: 'https://image.dev-amondz.com/rectangle-images/d45cebc5-eb44-42d7-a78f-6faf4d6cf214.jpg',
          path: null,
          width: 1035,
          height: 1125,
        },
      ],
      '1': [
        {
          id: 2874,
          url: 'https://image.dev-amondz.com/rectangle-images/8f2dede5-2da8-4d95-aa53-a9ebc23d7645.jpg',
          path: null,
          width: 2892,
          height: 1500,
        },
      ],
    },
    no: 3,
    linkId: 2905,
    linkName: '기획전 테스트 - 기홍2',
    status: 2,
    url: 'https://image.dev-amondz.com/rectangle-images/d45cebc5-eb44-42d7-a78f-6faf4d6cf214.jpg',
    memo: '혜주테스트',
    eventPeriod: {
      startDate: null,
      endDate: null,
    },
    exposurePeriod: {
      startDate: '2024-03-28T09:01:57.000Z',
      endDate: '2024-04-04T09:01:57.000Z',
    },
  },
];

const HomeTabListPreview = (props: HomeTabListPreviewProps): JSX.Element => {
  const { tabList, onClose } = props;
  const [currentActive, setCurrentActive] = useState(0);

  return (
    <Modal
      title="홈 탭 미리보기"
      okText="저장"
      cancelText="취소"
      isOpen={true}
      width={375}
      height={600}
      isFooter={false}
      onClose={onClose}
    >
      <TabListPreviewStyle>
        <TabHeaderStyle>
          <PageHeader />
          <DragScroll>
            <TabHeaderListStyle>
              {tabList.map((tab, idx) => (
                <li
                  key={tab.id}
                  className={classNames('item', { active: currentActive === idx })}
                  onClick={(): void => setCurrentActive(idx)}
                >
                  <span>{tab.title}</span>
                </li>
              ))}
            </TabHeaderListStyle>
          </DragScroll>
        </TabHeaderStyle>
        <WidgetPreviewEventWrap widgetInfo={{}} exposureWidgetItemList={EVENT_MOCK_DATA} />
      </TabListPreviewStyle>
    </Modal>
  );
};

export default HomeTabListPreview;
